<template>
  <div class="
    uk-margin-large-top
    uk-margin-large-bottom
    uk-grid-match
    uk-padding-medium-left
   uk-grid">
    <USPCard
      :icon="usp1"
      link="/"
      title="Snelle Levering"
    >
      Ik probeer altijd binnen 24 uur te leveren. <br>Als dat even niet lukt dan overleggen we.
    </USPCard>

    <USPCard
      :icon="usp2"
      link="/"
      title="Ervaren actrice"
    >
      Ik heb veel ervaring met <br> voice-overs en acteren.
    </USPCard>

    <USPCard
      :icon="usp3"
      link="/"
      title="Alle tijd voor feedback"
    >
      Elke productie is anders. Samen komen <br> we tot de juiste tone of voice.
    </USPCard>
  </div>
</template>

<script>
import USPCard from '@/components/USPCard.vue';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const usp1 = require('@/assets/images/icons/icon-usp1@2x.png');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const usp2 = require('@/assets/images/icons/icon-usp2@2x.png');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const usp3 = require('@/assets/images/icons/icon-usp3@2x.png');

export default {
  name: 'USPCardContainer',
  data() {
    return {
      usp1: usp1.default ?? usp1,
      usp2: usp2.default ?? usp2,
      usp3: usp3.default ?? usp3,
    };
  },
  components: {
    USPCard,
  },
};
</script>

<style scoped>

</style>
